module.exports = __webpack_public_path__ + "media/categories/302-66b5c79f.svg";